import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { setTypeOfAccount } from "../../../features/accountDetails/accountDetailsSlice";

function BankAccount() {
    const dispatch = useDispatch();
    const optionDropdownRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { typeOfAccount } = useSelector((state) => state.accountDetails);
    const [selectedOption, setSelectedOption] = useState(typeOfAccount || "Operational Accounts");
    
    

    const handleClickOutsideDropdown = (event) => {
        try {
            const isClickInsideOptionDropdown = optionDropdownRef.current && optionDropdownRef.current.contains(event.target);
            if (!isClickInsideOptionDropdown) {
                setDropdownOpen(false);
            }
        } catch (error) {
            console.error("Error checking dropdown click:", error);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutsideDropdown);
        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    useEffect(() => {
        setSelectedOption(typeOfAccount || "Operational Accounts");
    }, [typeOfAccount]);

    const handleOptionSelect = (option) => {
        try {
            dispatch(setTypeOfAccount(option));
            setDropdownOpen(false);
        } catch (error) {
            console.error("Error selecting account type:", error);
        }
    };
    return (
        <div className="react-outer">
            <label>Type of account</label>
            <div className="custom-dropdown-user-new-outer">
                <div
                    className="selected-option custom-dropdown-user-new"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    ref={optionDropdownRef}
                >
                    {selectedOption}
                </div>
                {dropdownOpen && (
                    <div className="custom-dropdown-new">
                        <ul className="showing-options-list">
                            <li onClick={() => handleOptionSelect("Operational Accounts")}>
                                Operational Accounts
                            </li>
                            <li onClick={() => handleOptionSelect("Transaction Accounts")}>
                                Transaction Accounts
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BankAccount;